import ScrollOut from "scroll-out";

ScrollOut({
    targets: ".titolosezione__titoletto",
    onShown(el) {
        el.classList.add("titolosezione__titoletto--animated");
    }
});
